import {ParsedQs, stringify} from 'qs';
import {getPrettyUrlPath} from './getPrettyUrlPath.function';

export class PagewebUrl {
  private _origin?: string;
  private _path: string;
  private _queryparam: ParsedQs;
  private _openNewWindow: boolean;

  constructor({
    origin,
    path = '/',
    queryparam = {},
    openNewWindow = false,
  }: {
    origin?: string;
    path?: string;
    queryparam?: ParsedQs;
    openNewWindow?: boolean;
  }) {
    this._origin = origin;
    this._path = getPrettyUrlPath(path);
    this._queryparam = queryparam;
    this._openNewWindow = openNewWindow;
  }

  public putQuery({key, value}: {key: string; value: string}) {
    this._queryparam[key] = value;
  }
  /**
   * 이 객체가 표현하는 전체 URL을 반환합니다.
   *
   * origin + path + querystring
   */
  get fullUrl() {
    const validQueryparam = Object.keys(this._queryparam)
      .filter(key => !!this._queryparam[key])
      .reduce<{[key: string]: any}>(
        (prev, key) => ({...prev, [key]: this._queryparam[key]}),
        {}
      );
    const querystring =
      Object.keys(validQueryparam).length > 0
        ? `?${stringify(validQueryparam)}`
        : '';
    return `${this._origin || ''}${
      this._path ? this._path : '/'
    }${querystring}`;
  }

  get openNewWindow() {
    return this._openNewWindow;
  }

  get path() {
    return this._path;
  }

  get queryparam() {
    return this._queryparam;
  }
}
